import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "snapchat.cdp.cof";
export enum ChunkUploadPreference {
    PREFERENCE_UNSET = 0,
    GCS = 1,
    S3 = 2,
    AUTO = 3,
    UNRECOGNIZED = -1
}
export interface UploadSignals {
    chunkUploadSupportRequired: boolean;
    cloudfrontPop: string;
    gcdnPop: string;
    chunkUploadPreference: ChunkUploadPreference;
}
function createBaseUploadSignals(): UploadSignals {
    return { chunkUploadSupportRequired: false, cloudfrontPop: "", gcdnPop: "", chunkUploadPreference: 0 };
}
export const UploadSignals: MessageFns<UploadSignals> = {
    encode(message: UploadSignals, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.chunkUploadSupportRequired !== false) {
            writer.uint32(8).bool(message.chunkUploadSupportRequired);
        }
        if (message.cloudfrontPop !== "") {
            writer.uint32(18).string(message.cloudfrontPop);
        }
        if (message.gcdnPop !== "") {
            writer.uint32(26).string(message.gcdnPop);
        }
        if (message.chunkUploadPreference !== 0) {
            writer.uint32(32).int32(message.chunkUploadPreference);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): UploadSignals {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUploadSignals();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.chunkUploadSupportRequired = reader.bool();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.cloudfrontPop = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.gcdnPop = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.chunkUploadPreference = reader.int32() as any;
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<UploadSignals>, I>>(base?: I): UploadSignals {
        return UploadSignals.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<UploadSignals>, I>>(object: I): UploadSignals {
        const message = createBaseUploadSignals();
        message.chunkUploadSupportRequired = object.chunkUploadSupportRequired ?? false;
        message.cloudfrontPop = object.cloudfrontPop ?? "";
        message.gcdnPop = object.gcdnPop ?? "";
        message.chunkUploadPreference = object.chunkUploadPreference ?? 0;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
